/**
 * Format a number with thousands separators (e.g. 1000 -> "1,000").
 * Used for people counts and other figures shown in the UI.
 */
export function formatNumber(value: number): string {
  return value.toLocaleString('ja-JP');
}
